<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M6.41675 4.08332H7.58341V5.24999H6.41675V4.08332ZM6.41675 6.41666H7.58341V9.91666H6.41675V6.41666ZM7.00008 1.16666C3.78008 1.16666 1.16675 3.77999 1.16675 6.99999C1.16675 10.22 3.78008 12.8333 7.00008 12.8333C10.2201 12.8333 12.8334 10.22 12.8334 6.99999C12.8334 3.77999 10.2201 1.16666 7.00008 1.16666ZM7.00008 11.6667C4.42758 11.6667 2.33341 9.57249 2.33341 6.99999C2.33341 4.42749 4.42758 2.33332 7.00008 2.33332C9.57258 2.33332 11.6667 4.42749 11.6667 6.99999C11.6667 9.57249 9.57258 11.6667 7.00008 11.6667Z"
      fill="#2A2B2A"
      class="fill"
    />
  </svg>
</template>

<style lang="scss" scoped>
svg .fill {
  fill: #2a2b2a;
}

.icon-primary svg .fill {
  fill: #3273f6;
}
</style>
